module.exports = __webpack_public_path__ + "assets/img/item03.f75959d0.png";